"use strict";
class DeveloperPropertyAMLScansController {
    constructor($scope, $window, $timeout, Upload, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfigService, SSConfirmationService, OTPService, SettingsService, SSAppService, SSDateService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;

        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SettingsService = SettingsService;
        self.SSAppService = SSAppService;
        self.SSDateService = SSDateService;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.IDENTITY_TYPE_SINGAPOREAN = SHOWSUITE.IDENTITY_TYPE_SINGAPOREAN;
        self.IDENTITY_TYPE_SINGAPORE_PR = SHOWSUITE.IDENTITY_TYPE_SINGAPORE_PR;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;

        self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL = SHOWSUITE.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL;
        self.AML_CUSTOM_WATCH_LIST_TYPE_CORPORATE = SHOWSUITE.AML_CUSTOM_WATCH_LIST_TYPE_CORPORATE;
        self.AML_CUSTOM_WATCH_LIST_TYPE_BOTH = SHOWSUITE.AML_CUSTOM_WATCH_LIST_TYPE_BOTH;
        self.AML_CUSTOM_WATCH_LIST_STATUS_UPLOADED = SHOWSUITE.AML_CUSTOM_WATCH_LIST_STATUS_UPLOADED;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;
        self.showAMLScanPage = false;
        self.showCustomWatchlistView = false;
        self.showAddCustomWatchListView = false;
        self.showAMLListPage = true;
        self.selectedWatchList = null;
        self.watchList = {
            type: self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL
        }

        self.watchListError = {};
        self.initConstants();

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.showImport = true;
        self.amlScans = null;

        self.importParams = {};

        self.getPropertySettings();
    }

    initConstants(){
        const self = this;

        self.BUYER_TYPES = [
            {id: self.BUYER_TYPE_INDIVIDUAL, name: 'Individual'},
            {id: self.BUYER_TYPE_COMPANY, name: 'Company'}
        ];

        self.IDENTITY_TYPES = [
            {id: self.IDENTITY_TYPE_SINGAPOREAN, name: 'Singaporean'},
            {id: self.IDENTITY_TYPE_SINGAPORE_PR, name: 'Singapore PR'},
            {id: self.IDENTITY_TYPE_FOREIGNER, name: 'Foreigner'}
        ];

        self.WATCHLIST_TYPE = {
            individual: 'Individual',
            corporate: 'Corporate',
            both: 'Individual, Corporate'
        }
    }

    // API Calls
    getAMLScans(files) {
        const self = this;

        self.importParams.excelFile = files[0];

        if(!self.importParams.excelFile) {
            self.SSAlertService.danger('Please select file to import.');
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                self.parseExcel(self.importParams.excelFile);
            }
        );
    }

    parseExcel(file) {
        const self = this;

        self.amlScans = [];
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/properties/'+self.property.id+'/aml/upload-excel'),
            method: 'POST',
            data: {
                file_import: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.filesUploadProgress = 100;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.aml_scan_records){
            	self.amlScans = response.data.aml_scan_records
            }
            self.original_file_name = '';
            if(response.data && response.data.original_file_name){
                self.original_file_name = response.data.original_file_name;
            }

        }, function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
            //console.log(evt);
            //self.filesUploadProgress += evt;
        });
    }

    import() {
        const self = this;
        if (!self.amlScans || (self.amlScans && !self.amlScans.length)) return;
        let url = 'sec/developer/properties/'+self.property.id+'/aml/scan-and-download-report';
        let params = {
            data: JSON.stringify(self.amlScans)
        }
        if(self.original_file_name){
            params['original_file_name'] = self.original_file_name; // Add fields to FormData
        }
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(!response.sub_code == 305027){
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            if (response && response.status === 504) {
                self.SSAlertService.info(' ','AML Scan are in progress. Please refresh after few minutes.');
                self.isScanDownloadCallProcessComplete = true;
                return;
            }
            if(response.data && response.data.batch_aml_scan_history){
                    self.batch_aml_scans.push(response.data.batch_aml_scan_history);
                    self.showAMLScanPage = false;
                    self.showAMLListPage = true;
            }
        });


        // // Set a timeout for the request
        // const requestTimeout = 10; // Timeout duration in milliseconds (5 seconds)
        //
        // self.Upload.upload({
        //     url: self.SSHttpService.getApiURL('sec/developer/properties/'+self.property.id+'/aml/scan-and-download-report'),
        //     method: 'POST',
        //     body: params,
        //     timeout: requestTimeout // Specify timeout here
        // }).then(function(response) {
        //     // Handle success
        //     loading(false);
        //     self.data = response.data;
        // }).catch(function(error) {
        //     loading(false);
        //     if (error.status === 0) {
        //         self.SSAlertService.error('AML Scan are in progress. Please refresh after few minutes. ');
        //         self.isScanDownloadCallProcessComplete = true;
        //     } else {
        //         // Handle other types of errors
        //         self.errorMessage = 'An error occurred: ' + error.message;
        //     }
        // });
    }

    getAllAMLScansList() {
        const self = this;
        self.batch_aml_scans = [];
        let url = 'sec/developer/properties/'+self.property.id+'/aml/batch-scan-histories';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(!response.sub_code == 305027){
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            if(response.data && response.data.batch_aml_scan_histories.length > 0){
                self.batch_aml_scans = response.data.batch_aml_scan_histories;
            }
        });
    }

    // amlScanAndShowDataInTable(url, data, fileName = null) {
    //     const self = this;
    //
    //     let xhr = new XMLHttpRequest();
    //     xhr.open("POST", url, true);
    //     let formData = new FormData();
    //     formData.append("data", data); // Add fields to FormData
    //     if(self.original_file_name){
    //         formData.append("original_file_name", self.original_file_name); // Add fields to FormData
    //     }
    //     try {
    //         loading(true);
    //         let successHandler = function (event) {
    //             if(event.target.response && event.target.response.data && event.target.response.data.batch_aml_scans
    //                 && event.target.response.data.batch_aml_scans.length > 0){
    //                 self.batch_aml_scans = event.target.response.data.batch_aml_scans;
    //                 self.isScanDownloadCallProcessComplete = true;
    //             }
    //         };
    //         let errorHandler = function(event) {
    //             self.SSUtilService.readBlobAsText(event.target.response, function (text) {
    //                 let response = self.SSHttpService.validateResponse({
    //                     data: JSON.parse(text) // Convert to standard response format
    //                 });
    //                 self.$timeout(function () {
    //                     if (response instanceof Error) {
    //                         if (response.message) {
    //                             self.SSAlertService.danger(response.message);
    //                         } else {
    //                             self.SSAlertService.parseAndDisplayError(response);
    //                         }
    //                     } else {
    //                         self.SSAlertService.danger('Oops!! Something went wrong. Please contact support.');
    //                     }
    //                 });
    //             });
    //         };
    //         // TODO: Need to handle loadstart, loadend and progress events to show download progress on UI
    //         xhr.onload = function (event) {
    //             loading(false);
    //             if (event.target.status === 200) {
    //                 successHandler(event);
    //             } else {
    //                 errorHandler(event);
    //             }
    //         }
    //         xhr.onerror = function (event) {
    //             loading(false);
    //             errorHandler(event);
    //         }
    //         xhr.send(formData);
    //     } catch (ex) {
    //         loading(false);
    //         console.log(ex);
    //     }
    // }
    downloadFileWithFileURI(url){
        const self = this;

        if(!url){
            console.log("Something wrong with file url.");
            return;
        }

        window.open(url, '_blank');
    }

    calculateExpiration(document){
        const self = this;

        if(!document){
            return;
        }

        let deleted_at = document.deleted_at;
        if(!deleted_at || deleted_at.startsWith('0000-00-00')){
            $(".download_"+document.id).fadeOut('slow');
            return;
        }

        let date = self.SSDateService.toLocalDate(deleted_at);
        date.setDate(date.getDate());
        // Set the date we're counting down to
        var countDownDate = date.getTime();

        self.setExpiration(document, countDownDate);
    }
    setExpiration(document, countDownDate){
        const self = this;

        // Update the count down every 1 second
        var x = setInterval(function() {

            // Get today's date and time
            let currentDate = self.SSDateService.toLocalDate(new moment().utc().format('YYYY-MM-DD HH:mm:ss'));

            // Find the difference between now and the count down date
            var difference = countDownDate - currentDate.getTime();

            // If the count down is over, write some text
            if (difference < 0) {
                clearInterval(x);
                $(".download_"+document.id).hide();
                $(".send_email_"+document.id).hide();
                $("#expiration_"+document.id).text("EXPIRED");
                return;
            }

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(difference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((difference % (1000 * 60)) / 1000);

            // Output the result
            $("#expiration_"+document.id).text(days + "d " + hours + "h "
                + minutes + "m " + seconds + "s ");

        }, 1000);
    }

    openDeletePopup(document){
        const self = this;
        self.selectedDocument = document;
        self.showDeleteAMLScanFileModal = true;
        $('#deleteAMLScanFileModal').modal('show');
    }

    downloadAMLScanFile(document){
        let self = this;
        if(!document){
            return;
        }
        let url = 'sec/developer/properties/'+self.property.id+'/aml/'+document.id+'/batch-history-download';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.downloadFileWithFileURI(response.data.url);
        });
    }

    deleteFile(){
        let self = this;
        let document = self.selectedDocument;
        if(!document){
            return;
        }
        let url = 'sec/developer/properties/'+self.property.id+'/aml/'+document.id+'/delete';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            self.selectedDocument = null;
            self.showDeleteAMLScanFileModal = false;
            $('#deleteAMLScanFileModal').modal('hide');
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.code == 200){
                var objWithIdIndex = self.batch_aml_scans.findIndex((obj) => obj.id === document.id);
                self.batch_aml_scans.splice(objWithIdIndex, 1);
            }
        });
    }

    openSendEmailPopup(document){
        const self = this;
        self.selectedDocument = document;
        self.emailError = "";
        self.amlScanSendEmail = "";
        self.showAMLScanSendEmailModal = true;
        $('#amlScanSendEmail').modal('show');
    }


    sendEmail(){
        let self = this;
        let document = self.selectedDocument;
        if(!document){
            return;
        }
        if(!self.amlScanSendEmail){
            self.emailError = "Please enter valid emails with comma separated."
            return;
        }
        let url = 'sec/developer/properties/'+self.property.id+'/aml/'+document.id+'/email';
        let param = {
            emails : self.amlScanSendEmail,
        }
        loading(true);
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            loading(false);
            self.selectedDocument = null;
            self.showAMLScanSendEmailModal = false;
            $('#amlScanSendEmail').modal('hide');
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response.data && response.data.emails && response.data.emails.length > 0 ) {
                self.SSAlertService.success('Success!',  response.message);
            }
        });
    }
    // getCreatedByName(document){
    //     const self = this;
    //
    //     let created_by = document.created_by;
    //     let user = document.user;
    //
    //     var name = '--';
    //
    //     if(!(created_by && user)){
    //         return name;
    //     }
    //
    //     if(user){
    //         name = user.display_name ? user.display_name : user.first_name + " " + user.last_name;
    //     }
    //
    //     return name;
    // }

    getBuyerTypeName(type) {
        const self = this;

        let name = null;
        jQuery.each(self.BUYER_TYPES, function (i, buyerType) {
            if (buyerType.id == type) {
                name = buyerType.name;
                return false;
            }
        });

        return name;
    }

    getIdentityTypeName(type) {
        const self = this;

        let name = null;
        jQuery.each(self.IDENTITY_TYPES, function (i, identityType) {
            if (identityType.id == type) {
                name = identityType.name;
                return false;
            }
        });
        if(name == null){
            return type;
        }
        return name;
    }

    getPropertySettings() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/settings/aml_scan_details';

        self.SettingsService.getPropertySetting(url, 'aml_scan_details', function (response) {
            self.aml_scan_details = response.aml_scan_details;
            self.getAllAMLScansList();
            self.getAllCustomWatchList();
            if (!(self.aml_scan_details)) {
                self.aml_scan_details = {value:{}}; // Init empty
            }
        });
    }

    getAllCustomWatchList() {
        const self = this;
        self.customWatchList = [];
        let url = 'sec/developer/properties/'+self.property.id+'/member-check/custom-list';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(!response.sub_code == 305027){
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            if(response.data && response.data.aml_custom_watch_list && response.data.aml_custom_watch_list.length > 0){
                self.customWatchList = response.data.aml_custom_watch_list;
            }
        });
    }


    editWatchList(watchlist){
        const self = this;
        self.watchListError = {};
        self.watchList = {
            type: self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL
        };
        if(watchlist){
            self.selectedWatchList = watchlist;
            self.watchList = {
                type: self.getWatchListTypeIdBaseOnName(self.selectedWatchList.dataType),
                name: self.selectedWatchList.name,
                description: self.selectedWatchList.description,
            };
        }
        self.showAMLScanPage = false;
        self.showAMLListPage = false;
        self.showCustomWatchlistView = false;
        self.showAddCustomWatchlistView = true;
    }


    openDeleteWatchListPopup(watchlist){
        const self = this;
        self.selectedWatchList = watchlist;
        self.showDeleteCustomWatchListFileModal = true;
        $('#deleteCustomWatchListFileModal').modal('show');
    }

    deleteWatchListFile(){
        let self = this;
        let watchList = self.selectedWatchList;
        if(!watchList){
            return;
        }
        let url = 'sec/developer/properties/'+self.property.id+'/member-check/custom-list/'+watchList.id+'/delete';
        loading(true);
        self.SSHttpService.deleteAPIRequest(url).then(function (response) {
            loading(false);
            self.selectedWatchList = null;
            self.showDeleteCustomWatchListFileModal = false;
            $('#deleteCustomWatchListFileModal').modal('hide');
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.code == 200){
                self.getAllCustomWatchList();
            }
        });
    }

    fileSelectedForImportWatchList(files){
        const self = this;
        self.customWatchListFile = files[0];
    }

    fileSelectedForBothTypeImportWatchList(files, type){
        const self = this;
        if(type === self.WATCHLIST_TYPE.individual){
            self.indivudalCustomWatchListFile = files[0];
        }else if(type === self.WATCHLIST_TYPE.corporate){
            self.corporateCustomWatchListFile = files[0];
        }
    }

    importCustomWatchListExcel() {
        const self = this;
        self.watchListError = {};
        if(!self.watchList.name){
            self.watchListError.name = "Please enter name";
            return;
        }
        if(!self.customWatchListFile && self.watchList.type !== self.AML_CUSTOM_WATCH_LIST_TYPE_BOTH){
            self.watchListError.file = 'Please select file for upload.';
            return;
        }
        if((!self.indivudalCustomWatchListFile || !self.corporateCustomWatchListFile) && self.watchList.type === self.AML_CUSTOM_WATCH_LIST_TYPE_BOTH){
            self.watchListError.file = 'Please select both files for upload.';
            return;
        }
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;
        let data = null;
        if(self.watchList.type !== self.AML_CUSTOM_WATCH_LIST_TYPE_BOTH){
            data = {
                file_type: self.watchList.type,
                description: self.watchList.description,
                name: self.watchList.name,
                import_file	: self.customWatchListFile
            }
        }else{
            data = {
                file_type: self.watchList.type,
                description: self.watchList.description,
                name: self.watchList.name,
                import_file_individual	: self.indivudalCustomWatchListFile,
                import_file_corporate	: self.corporateCustomWatchListFile
            }
        }
        if(self.selectedWatchList){
            data['custom_list_id'] = self.selectedWatchList.id;
        }

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/properties/'+self.property.id+'/member-check/custom-list'),
            method: 'POST',
            data: data,
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;
            self.filesUploadProgress = 100;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }


            if(response.data){
                self.selectedWatchList = null;
                self.watchList.type = self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL;
                self.watchList.description= '';
                self.watchList.name= '';
                self.customWatchListFile = null;


                self.getAllCustomWatchList();
                self.showAMLScanPage = false;
                self.showAMLListPage = false;
                self.showAddCustomWatchlistView = false;
                self.showCustomWatchlistView = true;
            }

        }, function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);
            if(response.data && response.data.data && response.data.data.result && response.data.data.result.message){
                self.watchListError.file = response.data.data.result.message;
            }

        }, function (evt) {
            //console.log(evt);
            //self.filesUploadProgress += evt;
        });
    }

    selectType(type){
        const self = this;
        self.customWatchListFile = null;
        self.indivudalCustomWatchListFile = null;
        self.corporateCustomWatchListFile = null;

    }

    getWatchListType(id){
        const self = this;
        if(id == self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL){
            return self.WATCHLIST_TYPE.individual;
        }else if(id == self.AML_CUSTOM_WATCH_LIST_TYPE_CORPORATE){
            return self.WATCHLIST_TYPE.corporate;
        }else if(id == self.WATCHLIST_TYPE.both){
            return self.AML_CUSTOM_WATCH_LIST_TYPE_BOTH;
        }
    }

    getWatchListTypeIdBaseOnName(name){
        const self = this;
        if(name == self.WATCHLIST_TYPE.individual){
            return self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL;
        }else if(name == self.WATCHLIST_TYPE.corporate){
            return self.AML_CUSTOM_WATCH_LIST_TYPE_CORPORATE;
        }else if(name == self.WATCHLIST_TYPE.both ){
            return self.AML_CUSTOM_WATCH_LIST_TYPE_BOTH;
        }
        return '--';
    }

    getWatchListStatus(id){
        const self = this;
        if(id == self.AML_CUSTOM_WATCH_LIST_STATUS_UPLOADED){
            return "Uploaded";
        }
        return '--';
    }

    downloadCustomWatchListFile(watclist) {
        const self = this;
        if(!watclist){
            return;
        }
        self.filesUploadProgress = 0;
        let totalFilesCount = watclist.files.length;
        loading(true);

        for(let i=0; i<totalFilesCount; i++){
            self.Upload.upload({
                url: self.SSHttpService.getApiURL('sec/developer/properties/'+self.property.id+'/member-check/custom-list/'+watclist.files[i].id),
                method: 'GET',
                responseType: 'blob'
            }).then(function (response) {
                loading(false);
                if (response.code && response.code !== 200) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                const contentDisposition = response.headers('Content-Disposition');
                let filename = watclist.files[i].name; // Default filename

                if (contentDisposition && !filename) {
                    const matches = /filename="?([^";]+)"?/.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1]; // Use the filename from the header
                    }
                }
                const blob = new Blob([response.data], { type: response.data.type });
                const url = URL.createObjectURL(blob);

                // Create a link element
                const a = document.createElement('a');
                a.href = url;
                a.download = filename; // Change this to the desired file name and extension
                document.body.appendChild(a); // Append to the DOM
                a.click(); // Programmatically click the link to trigger the download
                document.body.removeChild(a); // Remove the link from the DOM

                // Release the object URL
                URL.revokeObjectURL(url);
            }, function (response) {
            }, function (evt) {
            });
        }


    }

    resetValues(){
        const self = this;
        self.watchListError = {};
        self.selectedWatchList = null;
        self.customWatchListFile = null;
        self.watchList.type = self.AML_CUSTOM_WATCH_LIST_TYPE_INDIVIDUAL;
        self.watchList.description= '';
        self.watchList.name= '';
        self.customWatchListFile = null;
        self.indivudalCustomWatchListFile = null;
        self.corporateCustomWatchListFile = null;

    }

}

DeveloperPropertyAMLScansController.$inject = ['$scope', '$window', '$timeout', 'Upload', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSConfirmationService', 'OTPService', 'SettingsService', 'SSAppService' , 'SSDateService'];
app.controller('DeveloperPropertyAMLScansController', DeveloperPropertyAMLScansController);
